import React, { useState } from "react";

function AmendDetailsModal({ contractor, managerEmail, onClose, onSuccess }) {
  const [newTitle, setNewTitle] = useState("");
  const [newDepartment, setNewDepartment] = useState("");
  const [newCompany, setNewCompany] = useState("");
  const [newManager, setNewManager] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [ticketNumber, setTicketNumber] = useState(null);
  
  const allBlank = !newTitle.trim() && !newDepartment.trim() && !newCompany.trim() && !newManager.trim();

  const handleSubmit = async () => {
    if (allBlank) return;
    setSubmitting(true);
    setSubmitError("");
    try {
      const response = await fetch("/api/raiseTicket", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "amendDetails",
          contractorEmail: contractor.email,
          contractorName: contractor.name,
          managerEmail,
          newTitle: newTitle.trim() || undefined,
          newDepartment: newDepartment.trim() || undefined,
          newCompany: newCompany.trim() || undefined,
          newManager: newManager.trim() || undefined,
        }),
      });
      if (!response.ok) throw new Error("Failed");
      const data = await response.json();
      setTicketNumber(data.ticketNumber);
      setSubmitted(true);
      setTimeout(() => onSuccess(), 1000);
    } catch {
      setSubmitError("Something went wrong raising the ticket. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const overlayStyle = {
    position: "fixed", inset: 0, background: "rgba(24,7,58,0.32)",
    zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center"
  };
  const modalStyle = {
    background: "#fff", borderRadius: "14px", padding: "36px 32px",
    width: "100%", maxWidth: "420px", boxShadow: "0 8px 40px rgba(24,7,58,0.18)",
    fontFamily: "Montserrat, sans-serif", position: "relative"
  };
  const labelStyle = { display: "block", fontSize: "11px", fontWeight: 700, color: "#79749c", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.06em" };
  const inputStyle = { width: "100%", boxSizing: "border-box", border: "1.5px solid #e2dff0", borderRadius: "7px", padding: "9px 12px", fontSize: "13px", fontFamily: "Montserrat, sans-serif", color: "#18073a", outline: "none" };

  if (submitted) {
    return (
      <div style={overlayStyle}>
        <div style={modalStyle}>
          <div style={{ textAlign: "center", padding: "12px 0" }}>
            <div style={{ fontSize: "32px", marginBottom: "12px" }}>✅</div>
            <div style={{ fontWeight: 700, fontSize: "16px", color: "#18073a", marginBottom: "8px" }}>Request submitted</div>
            <div style={{ fontSize: "13px", color: "#79749c", marginBottom: "24px" }}>{ticketNumber} has been raised for {contractor.name}.</div>
            <button onClick={onClose} style={{ background: "#18073a", color: "#fff", border: "none", borderRadius: "7px", padding: "10px 28px", fontSize: "13px", fontWeight: 700, cursor: "pointer", fontFamily: "Montserrat, sans-serif" }}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button onClick={onClose} style={{ position: "absolute", top: "16px", right: "18px", background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#79749c" }}>×</button>
        <h2 style={{ fontSize: "17px", fontWeight: 700, color: "#18073a", marginBottom: "4px" }}>Amend details</h2>
        <p style={{ fontSize: "12px", color: "#79749c", marginBottom: "24px" }}>{contractor.name} — fill in only the fields that need changing.</p>

        <div style={{ marginBottom: "14px" }}>
          <label style={labelStyle}>Job title</label>
          <input style={inputStyle} type="text" placeholder="Leave blank if unchanged" value={newTitle} onChange={e => setNewTitle(e.target.value)} />
        </div>
        <div style={{ marginBottom: "14px" }}>
          <label style={labelStyle}>Department</label>
          <input style={inputStyle} type="text" placeholder="Leave blank if unchanged" value={newDepartment} onChange={e => setNewDepartment(e.target.value)} />
        </div>
        <div style={{ marginBottom: "14px" }}>
          <label style={labelStyle}>Contracting Organisation</label>
          <input style={inputStyle} type="text" placeholder="Leave blank if unchanged" value={newCompany} onChange={e => setNewCompany(e.target.value)} />
        </div>
        <div style={{ marginBottom: "24px" }}>
          <label style={labelStyle}>Manager (email)</label>
          <input style={inputStyle} type="email" placeholder="Leave blank if unchanged" value={newManager} onChange={e => setNewManager(e.target.value)} />
        </div>

        {allBlank && <p style={{ fontSize: "12px", color: "#c0392b", marginBottom: "12px" }}>Please fill in at least one field.</p>}
        {submitError && <p style={{ fontSize: "12px", color: "#c0392b", marginBottom: "12px" }}>{submitError}</p>}

        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ background: "none", border: "1.5px solid #e2dff0", borderRadius: "7px", padding: "9px 20px", fontSize: "13px", fontWeight: 600, cursor: "pointer", color: "#79749c", fontFamily: "Montserrat, sans-serif" }}>Cancel</button>
          <button onClick={handleSubmit} disabled={submitting || allBlank} style={{ background: allBlank ? "#c0b8d8" : "#18073a", color: "#fff", border: "none", borderRadius: "7px", padding: "9px 20px", fontSize: "13px", fontWeight: 700, cursor: allBlank ? "not-allowed" : "pointer", fontFamily: "Montserrat, sans-serif" }}>
            {submitting ? "Submitting…" : "Submit request"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AmendDetailsModal;